import { EonUiIcon } from "@eon-ui/eon-ui-components-react";
import "./AuthComponent.scss";
import { useTranslation } from "@me8eon/translation";
import React from "react";
import { authenticateDebugName, useLogin, useUserData } from "@me8eon/react_authentication";
import { useDebug } from "@me8eon/debug";

export function AuthComponent() {
    const { name, loggedIn } = useUserData();
    const { login, logout, type } = useLogin();
    const debug = useDebug(authenticateDebugName);
    const t = useTranslation();
    const authTitle = loggedIn ? t("logOff") : t("logIn");
    if (type !== "msal") return <></>;
    return (
        <>
            {loggedIn && <div className="username">{name}</div>}
            <button
                className="auth-wrapper"
                id="tileTour4"
                onClick={() => {
                    loggedIn ? logout(debug) : login(debug);
                }}
                title={authTitle}
            >
                {/*{isExpired && <div className="loggedout-alert"></div>}*/}
                <EonUiIcon
                    title={authTitle}
                    size="normal"
                    name={loggedIn ? "logout" : "user_outline"}
                />
            </button>
        </>
    );
}

